export default "__VITE_ASSET__BrmTEWDA__"